import { useEffect } from "react"
import { teamItems, payrollItems, insightsItems, adminItems, supportItems, fleetItems } from "../constants"
import LeftMenuHeader from "./common/LeftMenuHeader"
import LeftMenuBlock from "./left-menu/LeftMenuBlock"
import { useMediaQuery } from "@mui/material"
import { useLocation } from "react-router-dom"
import { ReactComponent as ArrowLeft } from "../assets/images/home/arrow-left.svg"
import { ReactComponent as ArrowRight } from "../assets/images/home/arrow-right.svg"
import { ReactComponent as FleetWageLogoEev } from "../assets/images/fleet-wage-logo-rev.svg"
import { isUserSourceRestricted } from "../helpers/helpers"
import SettingsIcon from "../assets/images/sidebar/setting-2.svg"
import { ReactComponent as PackageRouteWageLogoRev } from "../assets/images/package-route-logo-rev.svg"
import { useDispatch, useSelector } from "react-redux"
import { actions } from "../store/data/data.reducers"
import EmployeeIcon from "../assets/images/sidebar/profile.svg"
import { getUser } from "../store/auth/auth.selectors"
import TimeOffIcon from "../assets/images/calendar-remove.svg";

const LeftMenu = ({ isCollapsed, setIsCollapsed, isOpen, setIsOpen }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const userData = useSelector(getUser)
  const isMobile = useMediaQuery("(max-width:990px)")
  const isUserRestricted = isUserSourceRestricted()

  useEffect(() => {
    if (isMobile && isOpen) {
      setIsOpen(false)
    }
  }, [location])

  const handleOpenMenu = () => {
    dispatch(actions.setIsCollapsed(!isCollapsed))
    localStorage.setItem("isMenuCollapsed", !isCollapsed)
    setIsCollapsed(!isCollapsed)
  }

  const filterMenuItems = (items) => {
    return items
      .filter((item) => {
        // Only include items that are not restricted or are restricted but the user is not restricted
        return !item.restricted || (item.restricted && !isUserRestricted)
      })
      .map((item) => {
        if (isUserRestricted) {
          if (item.name === "Settings") {
            return {
              ...item,
              name: "Custom Settings"
            }
          }
        }

        return item // Return the item as is if no modification is needed
      })
  }

  const hasProfile = teamItems.some(item => item.name === "My Profile");

  if(!hasProfile && userData.employee_id) {
    teamItems.unshift({
      name: "My Profile",
      icon: EmployeeIcon,
      url: "/profile",
    })
  }

  return (
    <div
      className="sidebar-sec scrollbar"
      style={{
        width: isCollapsed && !isMobile ? "100px" : isMobile ? "100%" : "200px",
        padding: "0 11px"
      }}>
      {!isMobile && <LeftMenuHeader isCollapsed={isCollapsed} />}

      {isMobile ? (
        isOpen && (
          <div className="sidebar-menus-sec">
            <div style={{ width: "100%", margin: "0 0 12px 9px" }}>
              {isUserRestricted && <PackageRouteWageLogoRev style={{ marginLeft: "-1.5rem" }} />}
              {!isUserRestricted && <FleetWageLogoEev />}
            </div>

            <div className="sidebar-top-sec">
              <LeftMenuBlock name="Insights" itemArray={insightsItems} />
              <LeftMenuBlock name="Team" itemArray={teamItems} />
              <LeftMenuBlock name="Payroll" itemArray={payrollItems} />
              <LeftMenuBlock name="Fleet" itemArray={fleetItems} />
            </div>

            <div style={{ width: "100%" }} className="sidebar-bottom-sec">
              {!isUserRestricted && (
                <div className="sidebar-bottom-sec" style={{ marginBottom: "25px" }}>
                  <LeftMenuBlock name="Support" itemArray={supportItems} />
                </div>
              )}
              <div className="sidebar-bottom-sec">
                <LeftMenuBlock name="Admin" itemArray={filterMenuItems(adminItems)} />
              </div>
            </div>
          </div>
        )
      ) : (
        <div className="sidebar-menus-sec">
          <div className="sidebar-top-sec">
            <LeftMenuBlock name="Insights" itemArray={insightsItems} isCollapsed={isCollapsed} />
            <LeftMenuBlock name="Team" itemArray={teamItems} isCollapsed={isCollapsed} />
            <LeftMenuBlock name="Payroll" itemArray={payrollItems} isCollapsed={isCollapsed} />
            <LeftMenuBlock name="Fleet" itemArray={fleetItems} isCollapsed={isCollapsed} />
          </div>

          <div style={{ width: "100%" }} className="sidebar-bottom-sec">
            {!isUserRestricted && (
              <div className="sidebar-bottom-sec" style={{ marginBottom: "25px" }}>
                <LeftMenuBlock name="Support" itemArray={supportItems} isCollapsed={isCollapsed} />
              </div>
            )}
            <div className="sidebar-bottom-sec">
              <LeftMenuBlock
                name="Other"
                itemArray={filterMenuItems(adminItems)}
                isCollapsed={isCollapsed}
              />
            </div>
          </div>

          <div className="sidebar-bottom-sec-collapse" onClick={handleOpenMenu}>
            {isCollapsed ? <ArrowRight /> : <ArrowLeft />}
          </div>
        </div>
      )}
    </div>
  )
}

export default LeftMenu
